import React from 'react';

export const OrderCardSkeleton: React.FC = () => {
  return (
    <>
      {[1, 2, 3].map((index) => (
        <div key={index} className="active-order-card skeleton-card">
          <div className="active-order-header">
            <div className="active-order-info">
              <div className="order-info-item">
                <span className="skeleton-box skeleton-icon"></span>
                <span className="skeleton-box skeleton-text"></span>
              </div>
              <div className="order-info-item">
                <span className="skeleton-box skeleton-icon"></span>
                <span className="skeleton-box skeleton-text"></span>
              </div>
              <div className="order-info-item">
                <span className="skeleton-box skeleton-icon"></span>
                <span className="skeleton-box skeleton-text"></span>
              </div>
            </div>
            <span className="order-expand-icon skeleton-box skeleton-icon-small"></span>
          </div>
        </div>
      ))}
    </>
  );
};

